
function NotaEliminacionAcentos(){
    return(
        <small className="form-text text-muted">Se eliminarán los acentos automáticamente al guardar la solicitud.</small>
    )
}

export default NotaEliminacionAcentos;